module.exports = __webpack_public_path__ + "img/Code Modularity.e9929997.svg";